const WEEKDAYS = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']

/**
 * Korte, menselijke aanduiding van hoe lang geleden een datum is. Onderbouwt de volgorde
 * in de keuzelijsten: de gebruiker ziet waarom iets bovenaan staat zonder dat we de
 * rangschikking hoeven uit te leggen.
 */
export function relativeDayLabel(iso: string, today = new Date()): string {
  const then = new Date(`${iso}T00:00:00`)
  const from = new Date(today.getFullYear(), today.getMonth(), today.getDate())
  const days = Math.round((from.getTime() - then.getTime()) / 86_400_000)

  if (days <= 0) return 'vandaag'
  if (days === 1) return 'gisteren'
  if (days < 7) return WEEKDAYS[then.getDay()]
  if (days < 14) return 'vorige week'
  return `${Math.round(days / 7)} weken terug`
}
